import React from "react";
import styles from "./PreLogin.module.scss";
import { ReactComponent as CompanyLogo } from "../../images/SVG/CompanyLogo.svg";
import HeroSignupImage from "../../images/Group 18648.png";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import CreativesLogoSVG from "components/SVGComponents/CreativesLogoSVG";

const PreLogin = () => {
  const location = useLocation();

  if (location.pathname === "/") {
    return <Navigate to="/signin" />;
  }

  return (
    <main id={styles.preLogin}>
      <section className={styles.rightsection}>
        <Outlet />
      </section>
    </main>
  );
};

export default PreLogin;
